import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class NormativeService {

  constructor(private http: HttpClient, private serviceCallUtilsService: ServiceCallUtilsService) { }
  /**
  * Description: Método que llama el servicio web que obtiene las normativas
  * Autor: Fernando Herdoiza
  * @return Listado de normativas
  */
  getAllNormative() {
    return this.serviceCallUtilsService.callPostWebService(constants.ENDPOINT_NORMATIVE, {});
  }

}
